var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShorts = function SvgShorts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4096 0.455038C13.401 -0.559633 15.8667 0.179531 16.9148 2.1064C17.9629 4.03327 17.1983 6.41708 15.2069 7.43175L13.5694 8.27339C14.9801 8.32378 16.3254 9.08143 17.0299 10.3766C18.078 12.3035 17.3151 14.6873 15.322 15.702L6.59004 20.1874C4.59863 21.2021 2.133 20.4629 1.08489 18.536C0.0367759 16.6091 0.801381 14.2253 2.79279 13.2107L4.43025 12.369C3.01959 12.3186 1.67423 11.561 0.969766 10.2658C-0.0783443 8.3389 0.68626 5.9551 2.67767 4.94042L11.4096 0.455038ZM6.69657 7.14448L11.9818 10.3346L6.69657 13.5097V7.14448Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShorts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shorts.22ff2746.svg";
export { ForwardRef as ReactComponent };